// extracted by mini-css-extract-plugin
var _1 = "fKfwQ5pfTJ";
var _2 = "kJKvI5QwSm";
export { _1 as "altIcon", _2 as "root" }
